"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.illustrations = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var illustrations = exports.illustrations = {
  noData: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: "134",
    height: "103",
    viewBox: "0 0 134 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
      cx: "67.4178",
      cy: "93.6361",
      rx: "58.0545",
      ry: "9.36364",
      fill: "#F1F1FD"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M99.8088 38.3906H87.8906V85.2088L89.7634 89.8906L94.4452 91.7634H99.8088C102.018 91.7634 103.809 89.9725 103.809 87.7634V42.3906C103.809 40.1815 102.018 38.3906 99.8088 38.3906Z",
      fill: "#F1F1FD"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M96.3179 39.3278H87.8906V37.4551H96.3179C100.972 37.4551 104.745 41.2281 104.745 45.8824V84.2733C104.745 88.9275 100.972 92.7005 96.3179 92.7005H94.4452V90.8278H96.3179C99.9379 90.8278 102.872 87.8932 102.872 84.2733V45.8824C102.872 42.2624 99.9379 39.3278 96.3179 39.3278Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M31.9648 15.2363C31.9648 13.0272 33.7557 11.2363 35.9648 11.2363H83.8921C86.1013 11.2363 87.8921 13.0032 87.8921 15.2123C87.8921 29.5236 87.8921 77.9008 87.8921 84.2727C87.8921 91.7636 95.383 91.7636 95.383 91.7636H38.9648C35.0988 91.7636 31.9648 88.6296 31.9648 84.7636V15.2363Z",
      fill: "white"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M31.0273 18.7271C31.0273 14.0728 34.8004 10.2998 39.4546 10.2998H80.4001C85.0502 10.2998 88.8273 14.0435 88.8273 18.7019V84.2725C88.8273 85.9814 89.2519 87.2008 89.8405 88.0838C90.4331 88.9727 91.2299 89.5769 92.0552 89.9896C92.8841 90.404 93.7244 90.616 94.3654 90.7228C94.6836 90.7758 94.9468 90.802 95.1267 90.8148C95.2165 90.8212 95.2851 90.8243 95.329 90.8258L95.3755 90.827L95.3819 90.8271C95.3819 90.8271 95.3819 90.8271 95.3819 91.7634V92.6998H39.4546C34.8004 92.6998 31.0273 88.9268 31.0273 84.2725V18.7271ZM89.8774 90.8271C89.296 90.3776 88.7461 89.8183 88.2823 89.1226C87.4665 87.8988 86.9546 86.3091 86.9546 84.2725V18.7019C86.9546 15.086 84.0242 12.1725 80.4001 12.1725H39.4546C35.8346 12.1725 32.9001 15.1071 32.9001 18.7271V84.2725C32.9001 87.8925 35.8346 90.8271 39.4546 90.8271H89.8774Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M68.4571 29.5352L76.6078 38.7047L75.2081 39.9488L68.3769 32.2638L63.4609 37.1798L62.1367 35.8555L68.4571 29.5352Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M54.3466 26.7393L64.2721 36.6647L62.9479 37.989L54.4006 29.4417L43.8253 40.8983L42.4492 39.6281L54.3466 26.7393Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M104.873 0H103.001V7.49091L95.5098 7.49091V9.36364H103.001V16.8545H104.873V9.36364H112.364V7.49091L104.873 7.49091V0Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M116.109 20.5996H114.236V22.4723H112.363V24.3451H114.236V26.2178H116.109V24.3451H117.981V22.4723H116.109V20.5996Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M24.3451 1.87305H22.4723V3.74577H20.5996V5.6185H22.4723V7.49123H24.3451V5.6185H26.2178V3.74577H24.3451V1.87305Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M3.74545 65.5459H1.87273V67.4186H0V69.2914H1.87273V71.1641H3.74545V69.2914H5.61818V67.4186H3.74545V65.5459Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M20.6006 71.1641H18.7279V74.9095H14.9824V76.7822H18.7279V80.5277H20.6006V76.7822H24.3461V74.9095H20.6006V71.1641Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "45",
      y: "50",
      width: "3",
      height: "3",
      transform: "rotate(90 45 50)",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "45",
      y: "63",
      width: "3",
      height: "3",
      transform: "rotate(90 45 63)",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "45",
      y: "76.5",
      width: "3",
      height: "3",
      transform: "rotate(90 45 76.5)",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "75.5293",
      y: "50.5635",
      width: "1.87",
      height: "23.84",
      transform: "rotate(90 75.5293 50.5635)",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "75.5293",
      y: "63.6729",
      width: "1.87",
      height: "23.84",
      transform: "rotate(90 75.5293 63.6729)",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "75.5293",
      y: "76.7822",
      width: "1.87",
      height: "23.84",
      transform: "rotate(90 75.5293 76.7822)",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M35.7084 35.5817C35.7084 42.8217 29.8393 48.6908 22.5993 48.6908C15.3594 48.6908 9.49023 42.8217 9.49023 35.5817C9.49023 28.3418 15.3594 22.4727 22.5993 22.4727C29.8393 22.4727 35.7084 28.3418 35.7084 35.5817Z",
      fill: "#F1F1FD"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.6001 23.4089C15.8773 23.4089 10.4274 28.8588 10.4274 35.5816C10.4274 42.3044 15.8773 47.7543 22.6001 47.7543C29.323 47.7543 34.7729 42.3044 34.7729 35.5816C34.7729 28.8588 29.323 23.4089 22.6001 23.4089ZM8.55469 35.5816C8.55469 27.8245 14.8431 21.5361 22.6001 21.5361C30.3572 21.5361 36.6456 27.8245 36.6456 35.5816C36.6456 43.3387 30.3572 49.627 22.6001 49.627C14.8431 49.627 8.55469 43.3387 8.55469 35.5816Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M22.6009 28.0908H20.7282V29.9635L18.8555 29.9635V31.8363H20.7282V33.709H22.6009V31.8363H24.4737V29.9635L22.6009 29.9635V28.0908Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "16.9824",
      y: "39.3271",
      width: "1.87273",
      height: "1.87273",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M132.836 58.9914C132.836 64.6799 128.225 69.2914 122.536 69.2914C116.848 69.2914 112.236 64.6799 112.236 58.9914C112.236 53.3029 116.848 48.6914 122.536 48.6914C128.225 48.6914 132.836 53.3029 132.836 58.9914Z",
      fill: "#F1F1FD"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M122.537 49.6276C117.366 49.6276 113.174 53.8199 113.174 58.9912C113.174 64.1626 117.366 68.3549 122.537 68.3549C127.709 68.3549 131.901 64.1626 131.901 58.9912C131.901 53.8199 127.709 49.6276 122.537 49.6276ZM111.301 58.9912C111.301 52.7856 116.331 47.7549 122.537 47.7549C128.743 47.7549 133.774 52.7856 133.774 58.9912C133.774 65.1969 128.743 70.2276 122.537 70.2276C116.331 70.2276 111.301 65.1969 111.301 58.9912Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M122.859 54.7162C122.191 54.9603 121.648 55.4596 121.444 55.7649L119.886 54.7261C120.307 54.095 121.168 53.3401 122.217 52.9571C123.317 52.5551 124.702 52.5453 125.949 53.5919C126.98 54.4573 127.381 55.5063 127.275 56.5892C127.177 57.5961 126.652 58.5176 126.094 59.2553C125.713 59.7585 125.207 60.0853 124.733 60.3247C124.369 60.5085 123.962 60.6691 123.6 60.8122C123.503 60.8505 123.409 60.8876 123.32 60.9235C122.387 61.2996 121.797 61.6293 121.503 62.2188C121.271 62.6813 120.709 62.8688 120.246 62.6375C119.784 62.4063 119.596 61.8438 119.828 61.3813C120.469 60.098 121.704 59.5557 122.619 59.1866C122.739 59.1381 122.854 59.0929 122.963 59.0497C123.311 58.9122 123.609 58.7944 123.889 58.6532C124.243 58.4741 124.464 58.3048 124.6 58.1251C125.076 57.4967 125.362 56.9088 125.411 56.4072C125.453 55.9816 125.337 55.5231 124.745 55.0263C124.119 54.5009 123.475 54.4912 122.859 54.7162Z",
      fill: "#D3D3DF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M117.855 63.6729H119.728V65.5456H117.855V63.6729Z",
      fill: "#D3D3DF"
    })]
  })
};